import { get, post } from '@/lib/api/client'
import {
  PaginationParamsSchema,
  HistoryFilterParamsSchema,
  type History,
  type HistoryDetail,
  type HistoryFilterParams,
  type ApiResponse,
  type PaginatedResponse,
  type PaginationParams
} from '@/lib/api/types'

export class HistoryService {
  /**
   * Filter histories (Public endpoint)
   * POST /histories/public/filter
   */
  async filterHistories(
    filters: HistoryFilterParams = {}
  ): Promise<ApiResponse<PaginatedResponse<History>>> {
    const validatedFilters = HistoryFilterParamsSchema.parse(filters)

    return await post<ApiResponse<PaginatedResponse<History>>>(
      'histories/public/filter',
      validatedFilters
    )
  }

  /**
   * Search histories (Public endpoint)
   * GET /histories/public/search?searchBy={searchTerm}&size={size}&page={page}
   */
  async searchHistories(
    searchTerm: string,
    params: PaginationParams = { page: 1, size: 10 }
  ): Promise<ApiResponse<PaginatedResponse<History>>> {
    const validatedParams = PaginationParamsSchema.parse(params)

    const query = new URLSearchParams({
      searchBy: searchTerm,
      size: validatedParams.size.toString(),
      page: validatedParams.page.toString()
    }).toString()

    return await get<ApiResponse<PaginatedResponse<History>>>(
      `histories/public/search?${query}`
    )
  }

  /**
   * Get history by ID (Public endpoint)
   * GET /histories/public/{historyId}
   */
  async getHistoryById(historyId: string): Promise<ApiResponse<HistoryDetail>> {
    return await get<ApiResponse<HistoryDetail>>(
      `histories/public/${historyId}`
    )
  }
}

// Export singleton instance
export const historyService = new HistoryService()

// Export default
export default historyService

